"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash"); // export interface PlateElement {
//   type: PlateElementType;
//   troughIndex?: number;
//   position: PlateElementPosition;
//   buffer: PlateElementBuffer;
//   scale: PlateElementScale;
//   isFixed?: boolean;
//   behaviour: 'relative' | 'absolute';
//   isFirst: boolean;
//   isLast: boolean;
//   placeConsoleThreshold?: number;
//   spaceBeforeNext?: number;
//   placeConsoleAt?: number;
//   material?: PlateElementMaterial;
//   elements?: PlateElement[];
//   rotate: PlateElementRotate;
//   sides: PlateElementSides;
//   isVisible: boolean;
//   isSubstraction: boolean;
//   // Might break out below types into 2 different interfaces, but was complicated things so leaving out for now
//   fileName?: string;
//   shape?: 'box' | 'cylinder';
//   thickness?: number;
//   sidesfunc: any;
// }


exports.keyElements = ['trough', 'tap', 'soap-dispenser', 'edge', 'wall', 'cut-out', 'safety-catch']; // Took out safety catch as key element...

exports.surfaceElements = ['plate', 'trough', 'apron', 'surge-edge', 'back-splash', 'corner-radius'];
exports.overhangElements = ['trough', 'angle-bar', 'console', 'edge', 'wall', 'cut-out', 'tap', 'soap-dispenser', 'consolecenteranchor']; // Safety catch is actually reducing the distance needed for a console I think

exports.centerableElements = ['console', 'cut-out', 'tissue-dispenser'];
exports.asssemblyElements = ['console', 'angle-bar', 'safety-catch'];
exports.edgeElements = ['wall', 'edge', 'apron', 'spacer'];
exports.affixableElements = ['trough', 'tap', 'soap-dispenser', 'cut-out'];

var PlateElement =
/** @class */
function () {
  function PlateElement(overrides) {
    if (overrides === void 0) {
      overrides = {};
    }

    this.type = 'empty';
    this.behaviour = 'relative';
    this.position = {
      x: 0,
      y: 0,
      z: 0
    };
    this.buffer = {
      left: 0,
      right: 0,
      front: 0,
      back: 0
    };
    this.scale = {
      x: 0,
      y: 0,
      z: 0
    };
    this.rotate = {
      x: 0,
      y: 0,
      z: 0
    };
    this.isFirst = false;
    this.isLast = false;
    this.isVisible = false;
    this.isSubstraction = false;
    this.isFixed = false;
    this.isStretched = false;
    this.isLimited = false;
    this.materialName = 'test';
    this.hidden = false;

    if (!overrides.materialName || typeof overrides.materialName === 'undefined') {
      if (exports.surfaceElements.includes(overrides.type)) {
        overrides.materialName = 'white';
      } else {
        overrides.materialName = 'stainlessSteel';
      }
    }

    if (overrides) {
      lodash_1.merge(this, overrides);
    } // Make get props available after json.stringify


    Object.defineProperty(this, 'outerWidth', {
      enumerable: true,
      configurable: true,
      get: this.outerWidthFunction
    });
    Object.defineProperty(this, 'outerSides', {
      enumerable: true,
      configurable: true,
      get: this.outerSidesFunction
    });
    Object.defineProperty(this, 'sides', {
      enumerable: true,
      configurable: true,
      get: this.sidesFunction
    });
    Object.defineProperty(this, 'material', {
      enumerable: true,
      get: this.materialFunction
    });
  }

  Object.defineProperty(PlateElement.prototype, "isKeyElement", {
    get: function get() {
      return exports.keyElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isOverhangElement", {
    get: function get() {
      return exports.overhangElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isAssemblyElement", {
    get: function get() {
      return exports.asssemblyElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isEdgeElement", {
    get: function get() {
      return exports.edgeElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isSurfaceElement", {
    get: function get() {
      return exports.surfaceElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isAffixableElement", {
    get: function get() {
      return exports.affixableElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "isCenterableElement", {
    get: function get() {
      return exports.centerableElements.includes(this.type);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "hasPositionSet", {
    get: function get() {
      return this.position.x !== 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "hasScaleSet", {
    get: function get() {
      return this.scale.x !== 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PlateElement.prototype, "outerWidth", {
    get: function get() {
      return this.outerWidthFunction();
    },
    enumerable: true,
    configurable: true
  });

  PlateElement.prototype.outerWidthFunction = function () {
    return this.scale.x + this.buffer.right + this.buffer.left;
  };

  Object.defineProperty(PlateElement.prototype, "outerSides", {
    get: function get() {
      return this.outerSidesFunction();
    },
    enumerable: true,
    configurable: true
  });

  PlateElement.prototype.outerSidesFunction = function () {
    var sides = this.sidesFunction();
    sides.left = sides.left - this.buffer.left;
    sides.right = sides.right + this.buffer.right;
    return sides;
  };

  Object.defineProperty(PlateElement.prototype, "sides", {
    get: function get() {
      return this.sidesFunction();
    },
    enumerable: true,
    configurable: true
  });

  PlateElement.prototype.sidesFunction = function () {
    // Have to calculate the sides properly for backwall/normal trough...
    return {
      left: this.position.x - this.scale.x / 2,
      right: this.position.x + this.scale.x / 2,
      top: this.position.y + this.scale.y / 2,
      bottom: this.position.y - this.scale.y / 2,
      front: this.position.z + this.scale.z / 2,
      back: this.position.z - this.scale.z / 2
    };
  };

  Object.defineProperty(PlateElement.prototype, "material", {
    get: function get() {
      return this.materialFunction();
    },
    enumerable: true,
    configurable: true
  });

  PlateElement.prototype.materialFunction = function () {
    switch (this.materialName) {
      case 'black-white':
        return 'blackWhite';

      case 'light-gray':
        return 'lightGray';

      case null:
        return 'test';

      default:
        return this.materialName;
    }
  };

  return PlateElement;
}();

exports.PlateElement = PlateElement; // export class PlateElementTrough extends PlateElement {
//   troughIndex: number = 0;
//   public get sides(): PlateElementSides {
//     const sides = super.sidesFunction();
//     return PlateElement.prototype.sides; 
//     // How do I see if it's preparedBackwall or not from inside here the element...
//     // I think I can't actually, and perhaps need to do something from inside the builder
//     // I could also pass in the raw trough object too I guess...
//   }
// }